"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propsMain = _interopRequireDefault(require("./props-main"));
var _formTabs = _interopRequireDefault(require("./form-tabs"));
var _formData = _interopRequireDefault(require("./form-data"));
var _formButton = _interopRequireDefault(require("./form-button"));
var _default = exports.default = [_formButton.default, _formTabs.default, _formData.default, _propsMain.default];